var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn expand",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.expanded ? _vm.$t("COMMON.REDUCE_MODAL") : _vm.$t("COMMON.EXPAND_MODAL"))+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('img',{attrs:{"src":"/img/kw-expand.svg","alt":"icon"}})])
}]

export { render, staticRenderFns }